var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "420" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.params.title) } }),
          ]),
          _vm._v(" "),
          _c("v-card-text", {
            domProps: { innerHTML: _vm._s(_vm.params.text) },
          }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _vm.params.confirmText != "" && _vm.params.confirmText != null
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: _vm.params.color || "error" },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [
                      _vm.params.icon
                        ? _c("v-icon", { staticClass: "mr-2" }, [
                            _vm._v(_vm._s(_vm.params.icon)),
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.params.confirmText) +
                          "\n      "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.params.cancelText != "" && _vm.params.cancelText != null
                ? _c("v-btn", {
                    attrs: { color: "secondary", outline: "" },
                    domProps: { innerHTML: _vm._s(_vm.params.cancelText) },
                    on: {
                      click: function ($event) {
                        return _vm.cancel()
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }